import type { QVueGlobals } from 'quasar'

export type SsrScreenName = 'xs' | 'sm' | 'md'

export const ssrScreenName = ($q: QVueGlobals): SsrScreenName => {
  const ua = ($q.platform.userAgent || '').toLowerCase()
  const isMobile = $q.platform.is.mobile

  if (ua.includes('ipad') || (ua.includes('tablet') && !ua.includes('mobi'))) {
    return 'sm'
  }

  if (
    ua.includes('iphone')
    || ua.includes('ipod')
    || ua.includes('windows phone')
    || (ua.includes('android') && ua.includes('mobile'))
    || (ua.includes('mobile') && !ua.includes('ipad') && !ua.includes('tablet'))
    || isMobile
  ) {
    return 'xs'
  }

  return 'md'
}
